import { toast } from "react-hot-toast";

const toastConfig = {
  position: "top-center",
  toastOptions: {
    duration: 3000,
    style: {
      marginTop: "env(safe-area-inset-top, 25px)",
      background: "#363636",
      color: "#fff",
    },
  },
};
const SuccessToast = (message, type = "success") => {
  toast[type](message, {
    style: {
      background: "#10b981",
      color: "#fff",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#10b981",
    },
  });
};
const ErrorToast = (message, type = "error") => {
  toast[type](message, {
    style: {
      background: "#dc3545",
      color: "#fff",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#dc3545",
    },
  });
};

export { SuccessToast, ErrorToast, toastConfig };
